<template>
  <div>
    <div v-for="(topic, index) in content.topics" :key="topic.id">
      <b-card bg-variant="light" border-variant="primary" :class="{'mt-3': index !== 0}">
        <b-input-group>
          <b-form-input
            :value="topic.title"
            placeholder="Введите название"
            @input="onTopicTitleChange(index, topic, $event)"
            :disabled="index === content.topics.length - 1"
          ></b-form-input>

          <b-input-group-append >
            <b-button
              v-if="index !== content.topics.length - 1"
              variant="outline-primary"
              :disabled="!canMoveTopic(index,'up')"
              @click="onMoveTopic(index, 'up')"
            >
              <em class="fas fa-arrow-up"/>
            </b-button>
            <b-button
              v-if="index !== content.topics.length - 1"
              variant="outline-primary"
              :disabled="!canMoveTopic(index,'down')"
              @click="onMoveTopic(index, 'down')"
            >
              <em class="fas fa-arrow-down"/>
            </b-button>
            <b-button
              variant="outline-primary"
              v-b-tooltip.hover
              v-if="index !== content.topics.length - 1"
              title="Добавить раздел"
              @click="onAddSection(index)">
              <em class="fas fa-plus"/>
            </b-button>
            <b-button
              variant="primary"
              v-if="index !== content.topics.length - 1"
              v-b-tooltip.hover
              title="Удалить тему"
              @click="onDeleteTopic(index)"
            >
              <em class="fas fa-times"/>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-invalid-feedback :force-show="Boolean(invalidTopics[topic.id])">
          {{ invalidTopics[topic.id] }}
        </b-form-invalid-feedback>
      </b-card>
      <draggable
        :list="topic.sections"
        :group="index < content.topics.length - 1 ? 'sections' : 'testing'"
        class="pl-5"
        @end="onSectionMoved"
      >
        <!-- Цикл по разделам -->
        <div
          v-for="(section, sectionIndex) in topic.sections"
          :key="section.id">
          <b-card variant="outline-secondary" class="draggable-element">
            <b-input-group>
              <b-form-input
                :disabled="topic.title === 'Тестирование'"
                :value="section.title"
                placeholder="Введите название раздела"
                @input="onSectionTitleChange(index, sectionIndex, section, $event)"
              >
              </b-form-input> 
              <b-input-group-append>
                <b-button
                  v-if="topic.title !== 'Тестирование'"
                  variant="primary"
                  v-b-tooltip.hover
                  title="Удалить раздел"
                  @click="onDeleteSection(index, sectionIndex)">
                  <em class="fas fa-times"/>
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-form-invalid-feedback :force-show="Boolean(invalidSections[section.id])">
              {{ invalidSections[section.id] }}
            </b-form-invalid-feedback>
          </b-card>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: 'DraggableTopics',
  components: {
    draggable
  },
  props: {
    invalidTopics: {
      type: Object,
      default() {
        return {}
      }
    },
    invalidSections: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters({
      content: 'education/getCourseContent'
    })
  },
  methods: {
    onTopicTitleChange(index, topic, newTitle) {
      this.$emit('title-topic', {
        index,
        topic,
        newTitle
      })
    },
    onSectionTitleChange(topicIndex, sectionIndex, section, newTitle) {
      this.$emit('title-section', {
        topicIndex,
        sectionIndex,
        section,
        newTitle
      })
    },
    onMoveTopic(index, direction) {
      this.$emit('move-topic', {
        index,
        direction
      })
    },
    onSectionMoved() {
      this.$emit('move-section')
    },
    onAddSection(index) {
      this.$emit('add-section', index)
    },
    onDeleteTopic(index) {
      this.$emit('delete-topic', index)
    },
    onDeleteSection(topicIndex, sectionIndex) {
      this.$emit('delete-section', {
        topicIndex,
        sectionIndex
      })
    },
    canMoveTopic(internalId, direction) { // 'up', 'down'
      return !(internalId >= this.content.topics.length - 2 && direction === 'down'
        || internalId <= 0 && direction === 'up')
    }
  }
}
</script>

<style scoped>

.draggable-element {
  cursor: grab;
}
</style>
